import { Group, Skeleton, Stack } from '@mantine/core';

export function TableSkeleton() {
  return (
    <Stack gap={4} my='xs'>
      <Skeleton height={20} radius='xs' />
      {Array.from({ length: 10 }).map((_, i) => (
        <Skeleton key={i} height={90} radius='md' />
      ))}
      <Skeleton width={200} height={20} className='self-end' />
    </Stack>
  );
}

export function GroupActionsSkeleton() {
  return (
    <Group align='flex-start' justify='space-between' my='xs'>
      <Skeleton height={20} width={200} radius='md' />
      <Stack>
        <Skeleton height={35} width={300} radius='md' />
        <Skeleton height={10} width={300} radius='md' />
      </Stack>
    </Group>
  );
}

export function AssetsFallbackSkeleton() {
  return (
    <Stack w={1440}>
      <GroupActionsSkeleton />
      <TableSkeleton />
    </Stack>
  );
}

export function WorkflowsFallbackSkeleton() {
  return (
    <Stack mt='md' w={1440}>
      <Skeleton height={35} width={300} radius='md' />
      <Skeleton height={20} width={320} radius='md' />
      <TableSkeleton />
    </Stack>
  );
}

export function ListSkeleton() {
  return (
    <Stack>
      {Array.from({ length: 10 }).map((_, i) => (
        <Skeleton key={i} height={90} radius='md' />
      ))}
    </Stack>
  );
}

export function PublishedSkeleton() {
  return (
    <Stack gap='xs'>
      {Array.from({ length: 10 }).map((_, i) => (
        <Skeleton key={i} height={110} radius='md' />
      ))}
    </Stack>
  );
}
